import { Row } from '@tanstack/react-table'
import { useEffect } from 'react'

import { Table, TableHeader } from '@/ui/Table'
import { Disruption } from '@/types/disruptions'
import { Loader } from '@/ui/Loader'
import { useGetSharedDisruptions } from '../api/useGetSharedDisruptions'
import { useSharedDisruptionsTable } from '../hooks/useSharedDisruptionsTable'
import { useShowSharedDisruption } from '../hooks/useShowSharedDisruption'
import { DisruptionRow } from '@/pages/Disruptions/ui/components/DisruptionRow'
import { useClickOutside } from '@/helpers/useClickOutside'

import styles from '@/pages/Disruptions/ui/components/DisruptionsTable.module.scss'

export const SharedDisruptionsTable = () => {
    const { isLoading } = useGetSharedDisruptions()
    const { table, setRowSelection } = useSharedDisruptionsTable()

    const { sharedDisruptionId } = useShowSharedDisruption(isLoading)

    const tableRef = useClickOutside<HTMLTableElement>(() => {
        setRowSelection({})
    })

    const handleRowClick = (row: Row<Disruption>) => {
        setRowSelection({ [row.id]: true })
    }

    useEffect(() => {
        sharedDisruptionId && setRowSelection({ [sharedDisruptionId]: true })
    }, [sharedDisruptionId])

    if (isLoading) {
        return <Loader />
    }

    return (
        <div className={styles.root}>
            <div className={styles.tableContainer}>
                <Table className={styles.table} ref={tableRef}>
                    <TableHeader<Disruption> table={table} />
                    <tbody className={styles.tableBody}>
                        {table.getRowModel().rows.map((row) => (
                            <DisruptionRow key={row.id} row={row} handleRowClick={handleRowClick} table={table} />
                        ))}
                    </tbody>
                </Table>
            </div>
        </div>
    )
}
